/**
 * Single home for the admin's origins. Everything that talks to the API
 * or the preview iframe imports from here.
 */

export const API_BASE = import.meta.env.VITE_API_URL ?? 'https://api.valleyvitalitywellness.com';

export const SITE_ORIGIN =
  import.meta.env.VITE_SITE_ORIGIN ?? 'https://valleyvitalitywellness.com';

/** Origins the preview iframe may post from. */
export const ALLOWED_SITE_ORIGINS = new Set([
  SITE_ORIGIN,
  'https://valleyvitalitywellness.com',
  'https://www.valleyvitalitywellness.com',
]);
